<template>
  <button class="operate-btn" @click.stop="handleClick" :disabled="isLoading">
    <img
      v-if="isLoading"
      class="loading-icon"
      src="@saas/pages/assets/images/live/loading.png"
      alt="Loading..."
    />
    <template v-else>
      <slot v-if="isActive" name="active-icon"></slot>
      <slot v-else name="inactive-icon"></slot>
    </template>
  </button>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    handleClick() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.$emit("click-async");
    },
    setLoading(loading) {
      this.isLoading = loading;
    },
    setResult(success) {
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.operate-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 2px;

  img {
    width: 14px;
    height: 14px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .loading-icon {
    width: 14px;
    height: 14px;
    display: inline-block;
    animation: spin 1s linear infinite;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
